const config = {
    backendUrl: "https://chicosxbaires.runasp.net", // URL del backend
  };
  
  export default config;